<template>
  <main class="payment-page" role="main">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-5">
        <div class="container" v-if="action == 'recharge'">
          <div>
            <h1 class="section-title">{{ message }}</h1>
            <p
              class="text-normal"
            >Opps! There seems to have been an error with your payment. Please try again or contact support.</p>
          </div>
        </div>
        <div class="container" v-if="action == 'sim-order'">
          <div>
            <h1 class="section-title">{{ message }}</h1>
            <p
              class="text-normal"
            >Opps! There seems to have been an error with your payment. Please try again or contact support.</p>
            <p>
              <router-link
                class="btn-block btn btn-dark"
                :to="{ name: 'checkout' }"
                tag="button"
              >Back to Cart</router-link>
            </p>
          </div>
        </div>
        <div class="container" v-if="action == 'update-credit-card'">
          <div>
            <h1 class="section-title">{{ message }}</h1>
            <p
              class="text-normal"
            >Opps! There seems to have been an error with your payment. Please try again or contact support.</p>
            <p>
            <p class="text-normal">Please login to the manage area and try again.</p>
            <vue-login :username="username" redirect="/backend.html" @forgotPasswordChangedEvent="forgotPasswordChanged"></vue-login>         
            
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 image-section">
        <img
          class="img-fluid"
          src="/assets/images/backgrounds/me-you-activation-image.jpg"
          alt="Acivation-Input-Image"
        >
      </div>
    </div>
  </main>
</template>

<script>
import VueLogin from "@/components/elements/vue-login.vue";

export default {
  name: "payment-failed",
  components: {
    'vue-login': VueLogin
  },
  data: function() {
    return {
      message: "",
      action: false
    };
  },
  mounted() {
    var self = this;
    self.action = self.$route.query.action || null;
    self.message = self.$route.query.message || '';
    self.status = self.$route.query.status || 0;
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>